import { FC } from 'react'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const MensajePagoCorrecto: FC = () => {
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Pago Realizado!</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>Gracias por Comprar con Nosotros.</div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-3'>
        <img
          src={toAbsoluteUrl('/media/mensajePagado/correcto.png')}
          className='mw-100 mh-100px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/mensajePagado/correcto.png')}
          className='mw-100 mh-100px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/apps/ordenes-management/' className='btn btn-sm btn-primary'>
          Regresar a Ordenes
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export { MensajePagoCorrecto }
